import React from 'react';
import Grid from '@nubank/nuds-web/components/DeprecatedGrid/DeprecatedGrid';

import DeviceVideo from 'components/DeviceVideo/DeviceVideo';

import { StyledTypography } from '../../styles/Typography';

function SectionHowItWorks() {
  return (
    <Grid
      row
      spacingHorizontal={{ xs: '6x', md: '12x', lg: '14x' }}
      spacingVertical={{ xs: '12x', md: '20x', lg: '28x' }}
      alignItems={{ lg: 'center' }}
    >
      <Grid
        col={{ xs: 12, lg: 4 }}
        order={{ sm: 2 }}
        offset={{ lg: 1 }}
      >
        <Grid
          row
          justify="center"
          spacing="0"
        >
          <Grid col={{ md: 8, lg: 12 }}>
            <StyledTypography
              intlKey="INSURANCE.HOW_IT_WORKS.TITLE"
              variant="title"
              gutterBottom={{ xs: 1, md: 2, lg: 1 }}
            />
          </Grid>
        </Grid>
        <StyledTypography
          intlKey="INSURANCE.HOW_IT_WORKS.SUBTITLE"
          variant="subtitle"
          gutterBottom={{ xs: 2, md: 0 }}
        />
      </Grid>

      <Grid
        col={{ xs: 12, lg: 5 }}
        order={{ sm: 1, lg: 1 }}
        spacingBottom={{ sm: '8x', lg: '0' }}
        offset={{ lg: 1 }}
      >
        <DeviceVideo
          videoId="cAnwMCXW6SY"
          deviceType="dark"
          hasDeviceOnMobile
        />
      </Grid>
    </Grid>
  );
}

export default React.memo(SectionHowItWorks);
